module.exports = __webpack_public_path__ + "img/icon-menu.ce533117.svg";